import axios from 'axios'
import library from '../../../utils/Library'

export const unLockDeclarations = async (declId) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = library.getBaseAPIUrl('declarations') + '/unLockEntityLegalDecl'
  return await axios({
    url: URL,
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: {
      personalLegalDeclarationId: declId
    }
  })
}
